import React, { useEffect, useRef, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { ReactComponent as ArrowIcon } from 'assets/icons/convertBox/Arrow.svg';
import { ReactComponent as DoubleArrowIcon } from 'assets/icons/convertBox/DoubleArrow.svg';
import { Modal } from 'antd';
import ConvertBoxCoinsList from './coinsList/coinsList.index';
import { ConvertBoxCoinsListData } from './coinsList/coinsList.data';
import { __ConvertBoxCoinsListRef, _CoinsProps } from './coinsList/coinsList.interface';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { Button } from '30pay/components';
import { API } from 'data/30pay.api';
import { GetAllCoinType, MarketPriceBySymbol } from 'interfaces';
import { deleteCommaSeparator, get, irtToFixed, plainNumber, priceDigit } from 'scripts';
import { __ConvertBoxRef, __InitialConvertBoxProps, __TypeOfOrderEnum } from './initial.interface';
import { ConvertBoxDataType } from '../convertBox.index';
import { Card } from 'utilities/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH } from '../../../../data/30pay.path';
import { Link } from 'react-router-dom';
// import { ConvertBoxConfirmOrderModal } from './../confirmOrderModal/orderDetailModal.dashboard';

const ConvertBoxInitial: React.ForwardRefRenderFunction<__ConvertBoxRef, __InitialConvertBoxProps> = (
    props: __InitialConvertBoxProps,
    ref,
) => {
    React.useImperativeHandle(ref, () => ({
        setCoin: (coin) => setCoinFromOutside(coin),
    }));

    const USDT = ConvertBoxCoinsListData.find((item) => item.symbol === 'USDT');
    const TRX = ConvertBoxCoinsListData.find((item) => item.symbol === 'TRX');
    const IRT = ConvertBoxCoinsListData.find((item) => item.symbol === 'IRT');
    const SRC_COIN = IRT;
    const DEST_COIN = USDT;
    const [state, setState] = useState<__TypeOfOrderEnum>(__TypeOfOrderEnum.buy);
    const [srcCoin, setSrcCoin] = useState<GetAllCoinType | undefined>(SRC_COIN);
    const [isSrcSelectCoinOpen, setIsSrcSelectCoinOpen] = useState(false);
    const [destCoin, setDestCoin] = useState<GetAllCoinType | undefined>(DEST_COIN);
    const [isDestSelectCoinOpen, setIsDestSelectCoinOpen] = useState(false);
    const [srcPrice, setSrcPrice] = useState<MarketPriceBySymbol>();
    const [destPrice, setDestPrice] = useState<MarketPriceBySymbol>();
    const [srcValue, setSrcValue] = useState<string>();
    const [destValue, setDestValue] = useState<string>();
    const srcSelectedCoinListRef = useRef<__ConvertBoxCoinsListRef>(null);
    const destSelectedCoinListRef = useRef<__ConvertBoxCoinsListRef>(null);
    const [validateLoading, setValidateLoading] = useState(false);
    const navigate = useNavigate();
    const [isInitialDone, setIsInitialDone] = useState(true);
    // const [isOrderDetailModalOpen, setIsOrderDetailModalOpen] = useState<
    //     __ConvertBoxOrderDetailModalDataType | undefined
    // >();
    const location = useLocation();

    // changing state
    useEffect(() => {
        if (isInitialDone) {
            switch (state) {
                case __TypeOfOrderEnum.buy:
                    setSrcCoin(IRT);
                    setDestCoin(USDT);
                    break;
                case __TypeOfOrderEnum.sell:
                    setSrcCoin(USDT);
                    setDestCoin(IRT);
                    break;
                case __TypeOfOrderEnum.swap:
                    setSrcCoin(USDT);
                    setDestCoin(TRX);
                    break;
            }
        }
    }, [state]);

    function swapCoins() {
        const temp = srcCoin;
        setSrcCoin(destCoin);
        setDestCoin(temp);
    }

    function resetInputs() {
        setSrcValue('');
        setDestValue('');
    }

    useEffect(() => {
        if (isInitialDone) {
            resetInputs();
            setDestPrice(undefined);
        } else setIsInitialDone(true);

        if (destCoin?.symbol === 'IRT') {
            setDestPrice({ cryptoDollarPrice: 0, cryptoIrtBuyPrice: 1, cryptoIrtSellPrice: 1 });
        } else if (destCoin?.symbol) {
            get<MarketPriceBySymbol>(API.market.pricesBySymbol(destCoin?.symbol))
                .then((e) => {
                    setDestPrice(e.value.value);
                })
                .catch((e) => console.log(e));
        }
    }, [destCoin]);

    // change source coin
    useEffect(() => {
        if (isInitialDone) {
            resetInputs();
            setSrcPrice(undefined);
        }

        if (srcCoin?.symbol === 'IRT') {
            setSrcPrice({ cryptoDollarPrice: 0, cryptoIrtBuyPrice: 1, cryptoIrtSellPrice: 1 });
        } else if (srcCoin?.symbol) {
            get<MarketPriceBySymbol>(API.market.pricesBySymbol(srcCoin?.symbol))
                .then((e) => {
                    setSrcPrice(e.value.value);
                })
                .catch((e) => console.log(e));
        }
    }, [srcCoin]);

    // change value of inputs

    function changeInputHandler(value: string, type: 'src' | 'dest') {
        const newValue = plainNumber(value.replace(/[^۰-۹0-9,.]/g, ''));
        const isBuy = state === __TypeOfOrderEnum.buy;
        const key = isBuy ? 'cryptoIrtSellPrice' : 'cryptoIrtBuyPrice';

        if (type === 'src') {
            setSrcValue(newValue);
            if (newValue) {
                if (destPrice?.[key] && srcPrice?.[key]) {
                    const _srcValue = parseFloat(newValue);
                    const multiply =
                        _srcValue *
                        (srcPrice?.[state === __TypeOfOrderEnum.swap ? 'cryptoIrtSellPrice' : key] /
                            destPrice?.[state === __TypeOfOrderEnum.swap ? 'cryptoIrtBuyPrice' : key]);
                    const result = priceDigit(multiply);
                    if (result) setDestValue(result.toString());
                }
            } else {
                setDestValue('');
            }
        } else {
            setDestValue(newValue);
            if (newValue) {
                if (destPrice?.[key] && srcPrice?.[key]) {
                    const _destValue = parseFloat(newValue);
                    const multiply =
                        _destValue *
                        (destPrice?.[state === __TypeOfOrderEnum.swap ? 'cryptoIrtBuyPrice' : key] /
                            srcPrice?.[state === __TypeOfOrderEnum.swap ? 'cryptoIrtSellPrice' : key]);
                    const result = priceDigit(multiply);
                    if (result) setSrcValue(result.toString());
                }
            } else {
                setSrcValue('');
            }
        }
    }

    function closeSrcCoinsListModal() {
        srcSelectedCoinListRef.current?.reset();
        setIsSrcSelectCoinOpen(false);
    }

    function closeDestCoinsListModal() {
        destSelectedCoinListRef.current?.reset();
        setIsDestSelectCoinOpen(false);
    }

    function setCoinFromOutside(coin: _CoinsProps) {
        switch (state) {
            case __TypeOfOrderEnum.buy:
                setDestCoin(coin);
                break;
            case __TypeOfOrderEnum.sell:
                setSrcCoin(coin);
                break;
            default:
                setDestCoin(coin);
        }
    }

    // function submitHandler() {
    //     const output: __ConvertBoxOrderDetailModalDataType = {
    //         srcCoin,
    //         destCoin,
    //         typeOfOrder: state,
    //         srcValue,
    //         destValue,
    //         srcPrice: srcPrice,
    //         destPrice: destPrice,
    //     };
    //     setIsOrderDetailModalOpen(output);
    // }

    function onSubmitHandler() {
        if (srcCoin && destCoin && plainNumber(srcValue) && plainNumber(destValue)) {
            setValidateLoading(true);
            get(API.market.validate(srcCoin?.symbol, destCoin?.symbol, plainNumber(srcValue)!, plainNumber(destValue)!))
                .then(() => {
                    if (props.isPreview) {
                        navigate(
                            `${PATH.trade}?srcValue=${plainNumber(srcValue) ? parseFloat(plainNumber(srcValue)!) : 0}&srcCoinSymbol=${srcCoin?.symbol}&srcCoinName=${srcCoin?.name}&destValue=${plainNumber(destValue) ? parseFloat(plainNumber(destValue)!) : 0}&destCoinName=${destCoin?.name}&destCoinSymbol=${destCoin?.symbol}&typeOfOrder=${state}`,
                        );
                    } else {
                        const output: ConvertBoxDataType = {
                            srcValue: plainNumber(srcValue) ? parseFloat(plainNumber(srcValue)!) : undefined,
                            srcCoin,
                            destValue: plainNumber(destValue) ? parseFloat(plainNumber(destValue)!) : undefined,
                            destCoin,
                            typeOfOrder: state,
                        };
                        props.onSubmit(output);
                    }
                })
                .catch((err) => console.log(err))
                .finally(() => setValidateLoading(false));
        }
    }

    // auto fill the output based on the url (came from isPreview component)
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const srcValue = params.get('srcValue');
        const srcCoinName = params.get('srcCoinName');
        const srcCoinSymbol = params.get('srcCoinSymbol');
        const destValue = params.get('destValue');
        const destCoinName = params.get('destCoinName');
        const destCoinSymbol = params.get('destCoinSymbol');
        const typeOfOrder = params.get('typeOfOrder');
        const isInitial = params.get('isInitial');

        if (
            window.location.pathname === PATH.trade &&
            srcValue &&
            srcCoinName &&
            srcCoinSymbol &&
            destValue &&
            destCoinName &&
            destCoinSymbol &&
            typeOfOrder
        ) {
            const output: ConvertBoxDataType = {
                srcValue: parseFloat(deleteCommaSeparator(srcValue)),
                srcCoin: { name: srcCoinName, symbol: srcCoinSymbol },
                destValue: parseFloat(deleteCommaSeparator(destValue)),
                destCoin: { name: destCoinName, symbol: destCoinSymbol },
                typeOfOrder: parseInt(typeOfOrder) as __TypeOfOrderEnum,
            };
            if (!isInitial && isInitial !== 'true') {
                props.onSubmit(output);
            } else {
                setIsInitialDone(false);
                setSrcCoin({ symbol: srcCoinSymbol, name: srcCoinName });
                setDestCoin({ symbol: destCoinSymbol, name: destCoinName });
                setSrcValue(srcValue);
                setDestValue(destValue);
                setState(typeOfOrder === '1' ? __TypeOfOrderEnum.buy : __TypeOfOrderEnum.sell);
            }
            const newUrl = window.location.pathname; // Keep only the path
            window.history.pushState(null, '', newUrl);
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const symbol = params.get('symbol');

        if (symbol) {
            setCoinFromOutside({ symbol: symbol?.toUpperCase(), name: '' });
            window.scrollTo(0, 0);
        }
    }, [location.search]);

    return (
        <Card
            title={props.title}
            loading={!srcPrice || !destPrice}
            size={props.isPreview ? 'small' : 'default'}
            titleDivider={props.isPreview}
            url={props.isPreview ? '/trade' : undefined}
            className={`${props.isPreview ? 'flex-[0.422]' : ''}`}
        >
            <div className="flex flex-col overflow-hidden gap-5 w-full flex-1 h-full">
                {/* segment  */}
                <div className="flex items-center w-full md:text-base text-sm font-bold bg-[#F1F8FF] h-12 rounded-[32px] py-2 relative">
                    <div
                        className={`w-1/3 bg-primary-100 absolute h-full rounded-[32px] z-0 ${
                            state === __TypeOfOrderEnum.buy
                                ? 'right-0'
                                : state === __TypeOfOrderEnum.swap
                                  ? 'right-1/3'
                                  : 'right-2/3'
                        } transition-[right]`}
                    />
                    <div
                        onClick={() => setState(__TypeOfOrderEnum.buy)}
                        className="flex items-center h-full flex-1 gap-1 justify-center cursor-pointer transition-opacity hover:opacity-80 z-10"
                    >
                        <div
                            className={`rotate-180 text-${state === __TypeOfOrderEnum.buy ? 'white' : 'darkPurple-100'}`}
                        >
                            <ArrowIcon />
                        </div>
                        <label
                            className={`cursor-pointer ${state === __TypeOfOrderEnum.buy ? 'text-white' : 'text-darkPurple-100'}`}
                        >
                            خرید
                        </label>
                    </div>
                    <div
                        onClick={() => setState(__TypeOfOrderEnum.swap)}
                        className="flex items-center h-full flex-1 gap-1 justify-center transition-opacity hover:opacity-80 z-10 opacity-30 pointer-events-none cursor-not-allowed"
                    >
                        <div className={`text-${state === __TypeOfOrderEnum.swap ? 'white' : 'darkPurple-100'}`}>
                            <DoubleArrowIcon />
                        </div>
                        <label
                            className={`cursor-pointer ${state === __TypeOfOrderEnum.swap ? 'text-white' : 'text-darkPurple-100'}`}
                        >
                            تبادل ارز
                        </label>
                    </div>
                    <div
                        onClick={() => setState(__TypeOfOrderEnum.sell)}
                        className="flex items-center h-full flex-1 gap-1 justify-center cursor-pointer transition-opacity hover:opacity-80 z-10"
                    >
                        <div className={`text-${state === __TypeOfOrderEnum.sell ? 'white' : 'darkPurple-100'}`}>
                            <ArrowIcon />
                        </div>
                        <label
                            className={`cursor-pointer ${state === __TypeOfOrderEnum.sell ? 'text-white' : 'text-darkPurple-100'}`}
                        >
                            فروش
                        </label>
                    </div>
                </div>
                {/* inputs  */}
                <div className="relative flex flex-col gap-5 mt-1">
                    {/* src  */}
                    <div className="flex w-full items-center rounded-[32px] md:h-16 h-12 border border-primary-20 py-4 pr-6 pl-4">
                        <input
                            className="flex-1 outline-0 border-0 placeholder:text-base placeholder:font-medium text-base font-medium placeholder:text-darkPurple-40 text-darkPurple-100"
                            placeholder="تعداد را وارد کنید"
                            value={srcValue ? irtToFixed(srcCoin?.symbol ?? '', srcValue) : ''}
                            onChange={(e) => changeInputHandler(e.target.value, 'src')}
                        />
                        <Modal footer={null} open={isSrcSelectCoinOpen} onCancel={closeSrcCoinsListModal}>
                            <ConvertBoxCoinsList
                                ref={srcSelectedCoinListRef}
                                forbiddenCoins={destCoin ? [destCoin?.symbol] : undefined}
                                selectedCoin={srcCoin?.symbol}
                                onSelect={(item) => {
                                    setSrcCoin(item);
                                    closeSrcCoinsListModal();
                                }}
                            />
                        </Modal>
                        <div
                            onClick={() => setIsSrcSelectCoinOpen(true)}
                            className={`flex items-center gap-2 transition-opacity hover:opacity-65 cursor-pointer ${
                                state === __TypeOfOrderEnum.buy ? 'pointer-events-none' : ''
                            }`}
                        >
                            {state !== __TypeOfOrderEnum.buy && <IoIosArrowDown size={16} />}
                            <label className="md:text-base text-xs font-bold cursor-pointer text-darkPurple-100 mt-1 en">
                                {srcCoin?.symbol}
                            </label>

                            {srcCoin && <CoinIcon symbol={srcCoin?.symbol} className={'w-8 h-8'} />}
                        </div>
                    </div>
                    {/* swapBtn  */}
                    <div
                        onClick={swapCoins}
                        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full md:w-14 w-10 md:h-14 h-10 border-4 border-primary-20 flex items-center justify-center bg-primary-100 cursor-pointer transition-opacity hover:opacity-90 ${
                            state !== __TypeOfOrderEnum.swap
                                ? 'cursor-not-allowed pointer-events-none bg-primary-40 hover:opacity-100'
                                : ''
                        }`}
                    >
                        <div className="text-white scale-75 md:scale-100">
                            <DoubleArrowIcon />
                        </div>
                    </div>
                    {/* dest  */}
                    <div className="flex w-full items-center rounded-[32px] md:h-16 h-12 border border-primary-20 py-4 pr-6 pl-4">
                        <input
                            inputMode="numeric"
                            className="flex-1 outline-0 border-0 placeholder:text-base placeholder:font-medium text-base font-medium placeholder:text-darkPurple-40 text-darkPurple-100"
                            placeholder="قیمت نهایی"
                            value={destValue ? irtToFixed(destCoin?.symbol ?? '', destValue) : ''}
                            onChange={(e) => changeInputHandler(e.target.value, 'dest')}
                        />
                        <Modal footer={null} open={isDestSelectCoinOpen} onCancel={closeDestCoinsListModal}>
                            <ConvertBoxCoinsList
                                ref={destSelectedCoinListRef}
                                forbiddenCoins={srcCoin ? [srcCoin.symbol] : undefined}
                                selectedCoin={destCoin?.symbol}
                                onSelect={(item) => {
                                    setDestCoin(item);
                                    closeDestCoinsListModal();
                                }}
                            />
                        </Modal>
                        <div
                            onClick={() => setIsDestSelectCoinOpen(true)}
                            className={`flex items-center gap-2 transition-opacity hover:opacity-65 cursor-pointer ${
                                state === __TypeOfOrderEnum.sell ? 'pointer-events-none' : ''
                            }`}
                        >
                            {state !== __TypeOfOrderEnum.sell && <IoIosArrowDown size={16} />}
                            <label className="md:text-base text-xs font-bold cursor-pointer text-darkPurple-100 mt-1 en">
                                {destCoin?.symbol}
                            </label>
                            {destCoin && <CoinIcon symbol={destCoin?.symbol} className={'w-8 h-8'} />}
                        </div>
                    </div>
                </div>
                {/* online price  */}
                {state !== __TypeOfOrderEnum.swap && (
                    <div className="flex items-center w-full gap-2 mt-1">
                        <div className="rounded-full w-2 h-2 bg-primary-100" />
                        <label className="flex-1 md:text-base text-[14px] font-bold text-darkPurple-100">
                            قیمت لحظه ای {state === __TypeOfOrderEnum.sell ? srcCoin?.name : destCoin?.name}
                        </label>
                        <p className="font-medium md:text-sm text-[10px] flex items-center text-darkPurple-100">
                            (
                            {state === __TypeOfOrderEnum.sell
                                ? priceDigit(srcPrice?.cryptoDollarPrice)
                                : priceDigit(destPrice?.cryptoDollarPrice)}
                            <span className="en mt-[1px] text-[12px]">$</span>)
                        </p>
                        <h6 className="md:text-base text-xs font-bold text-darkPurple-100">
                            {state === __TypeOfOrderEnum.sell
                                ? priceDigit(srcPrice?.cryptoIrtBuyPrice)
                                : priceDigit(destPrice?.cryptoIrtSellPrice)}
                        </h6>
                        <span className="font-medium md:text-sm text-[14px] text-darkPurple-40">تومان</span>
                    </div>
                )}

                {/* Wallet Balance Section */}
                {props.wallet && state !== __TypeOfOrderEnum.swap && state === __TypeOfOrderEnum.buy && (
                    <div className="flex items-center w-full gap-2">
                        <div className="rounded-full w-2 h-2 bg-primary-100" />

                        <label className="flex-1 flex items-center gap-2 md:text-base text-[14px] font-bold text-darkPurple-100">
                            موجودی کیف پول:
                            {srcCoin?.symbol === 'IRT' && (
                                <Link
                                    to="/wallet/deposit"
                                    className="text-primary-100 md:text-sm text-[14px] font-bold cursor-pointer"
                                >
                                    افزایش موجودی
                                </Link>
                            )}
                        </label>

                        {/* BUY → show balance of srcCoin (IRT) */}
                        {state === __TypeOfOrderEnum.buy &&
                            (() => {
                                const asset = props.wallet.assets.find((a) => a.symbol === srcCoin?.symbol);
                                const balance = asset?.available ?? 0;

                                return (
                                    <>
                                        <span className="font-bold md:text-sm text-[10px] text-darkPurple-100">
                                            {priceDigit(balance.toFixed(0))}
                                        </span>

                                        <span className="font-medium md:text-sm text-[10px] text-darkPurple-40">
                                            تومان
                                        </span>
                                    </>
                                );
                            })()}
                    </div>
                )}

                {/* btn  */}
                <Button
                    loading={validateLoading}
                    disabled={!srcValue || !destValue}
                    onClick={onSubmitHandler}
                    type="primary"
                    size="large"
                >
                    {state === __TypeOfOrderEnum.buy ? 'خرید' : state === __TypeOfOrderEnum.sell ? 'فروش' : 'تبادل'}{' '}
                    {state === __TypeOfOrderEnum.sell
                        ? srcCoin?.name
                        : state === __TypeOfOrderEnum.buy
                          ? destCoin?.name
                          : `${srcCoin?.name} با ${destCoin?.name}`}
                </Button>
            </div>
        </Card>
    );
};
export default React.forwardRef(ConvertBoxInitial);
